// A1 starter-module completion. Stored as a boolean on the user's profile so it
// follows them across devices and can gate the dashboard "Start here" card.
import { pb } from "./pocketbase.js";
import { isAuthed, currentUser } from "./auth.js";

// Mark the A1 first-words module complete. Upserts the profile row (a brand-new
// learner may not have one yet — it's normally created on the first AI attempt).
export async function markStarterDone() {
  if (!isAuthed()) return { ok: false, reason: "guest" };
  const uid = currentUser()?.id;
  if (!uid) return { ok: false };
  try {
    const existing = await pb.collection("user_profiles").getFirstListItem(pb.filter("user_id = {:uid}", { uid }));
    await pb.collection("user_profiles").update(existing.id, { a1_starter_done: true });
    return { ok: true };
  } catch (_) {
    try {
      await pb.collection("user_profiles").create({ user_id: uid, a1_starter_done: true });
      return { ok: true };
    } catch (_e) {
      return { ok: false, reason: "error" };
    }
  }
}
